<router-outlet />
<app-root-menu />
<p-confirmDialog [closable]="false" />
<p-toast position="top-center" />
<app-spinner />
